/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosLinkFragment, LicenseCollapsedCardFragment } from "@cosmos/hygraph-schema";

import { CosmosText, CosmosTextVariantEnum, LicenseCollapsedCard, LicenseCollapsedCta } from "@components/elements";
import { css, cx } from "@panda/css";
import { Stack } from "@panda/jsx";

export type LicensesCollapsedCardsProps = {
	heading?: string | null;
	cards?: LicenseCollapsedCardFragment[] | null;
	cta?: CosmosLinkFragment | null;
};

export function LicensesCollapsedCards({ heading, cards = [], cta }: LicensesCollapsedCardsProps): React.JSX.Element {
	const contentfulCards = cards?.filter((card) => card.description?.html || card.title);
	const slicedCards = contentfulCards?.slice(0, 2);
	return (
		<Stack className="licenses-collapsed-cards" gap="eds.dimension.24">
			{heading ? <CosmosText variant={CosmosTextVariantEnum.headingLG} as="h3" text={heading} /> : null}
			<div
				className={cx(
					css({
						display: "flex",
						w: "full",
						flexDirection: "row",
						gap: "eds.dimension.16",
						lgDown: {
							flexDirection: "column",
						},
						"& .license-collapsed-card": {
							flex: 1,
						},
					}),
				)}
			>
				{slicedCards?.map((card, i) => (
					<LicenseCollapsedCard key={`licenses-collapsed-card-${i}`} {...card} />
				))}
			</div>
			<LicenseCollapsedCta {...cta} />
		</Stack>
	);
}
